import React, { useEffect, useState } from 'react';

// STYLES
import { Close, ModalContainer, ModalContent } from '../styles';

// SVGS
import { Close as CloseIcon } from '../svgs';

// COMPONENTS
import { Loader } from '../../Loader';

interface IModalImageProps {
  onClose: () => void;
  imageUrl: string;
  alt?: string;
}

const ModalImage = ({ onClose, imageUrl, alt = 'Image' }: IModalImageProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const handleContextmenu = (e) => {
      e.preventDefault();
    };
    document.addEventListener('contextmenu', handleContextmenu);
    return function cleanup() {
      document.removeEventListener('contextmenu', handleContextmenu);
    };
  }, []);

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  const handleImageError = () => {
    setIsLoading(false);
    setHasError(true);
  };

  return (
    <ModalContent>
      <ModalContainer>
        <Close onClick={onClose}>
          <CloseIcon />
        </Close>

        {isLoading && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '30vh',
              width: '40vw',
            }}
          >
            <Loader blue />
          </div>
        )}

        {hasError && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '200px',
              width: '100%',
              color: '#666',
              fontSize: '16px',
            }}
          >
            Erro ao carregar a imagem!
          </div>
        )}

        <img
          src={imageUrl}
          alt={alt}
          onLoad={handleImageLoad}
          onError={handleImageError}
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
            pointerEvents: 'none',
          }}
        />
      </ModalContainer>
    </ModalContent>
  );
};

export default ModalImage;
